const backendURL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : ''

const apiURL = `${backendURL}/api`

export { apiURL, backendURL }
